import React from 'react';
import { Container } from '@fiverr-private/layout_components';
import { SpinnerIcon, SpinnerL1Icon } from '@fiverr-private/visuals';
import { L1_SIZE_MAP, SYSTEM_SIZE_MAP } from './constants';
import type { LoaderProps } from './types';

const Loader = ({
  size = 'md',
  color = 'grey_1000',
  dataTestId,
  dataTrackTag = 'loader',
  ...restProps
}: LoaderProps) => {
  const { SpinnerComponent, iconSize } = Object.keys(SYSTEM_SIZE_MAP).includes(size)
    ? { SpinnerComponent: SpinnerIcon, iconSize: SYSTEM_SIZE_MAP[size] }
    : { SpinnerComponent: SpinnerL1Icon, iconSize: L1_SIZE_MAP[size] };

  return (
    <Container data-testid={dataTestId} display="flex" {...restProps} dataTrackTag={dataTrackTag}>
      <SpinnerComponent size={iconSize} color={color} />
    </Container>
  );
};

Loader.displayName = 'Loader';

export default Loader;
